import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {
  @Input() properties!: { header?: string, content?: string, id1?: string, id2?: string, id3?: string };
  @Input() template: any;
  @Input() templateHeader: any;
  @Input() defaultExpand: boolean = false;

  ngOnInit() {
    // Assign id for Bootstrap's JavaScript
    this.properties.id1 = 'A' + Math.random().toString().replace('.', '');
    this.properties.id2 = 'B' + Math.random().toString().replace('.', '');
    this.properties.id3 = 'C' + Math.random().toString().replace('.', '');
  }
}
